import { inject, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LegalPrivacyPolicyComponent } from '@app/legal/privacy-policy/privacy-policy.component';
import { LegalTermsOfUseComponent } from '@app/legal/terms-of-use/terms-of-use.component';
import { AgreementComponent } from '@app/root/components/agreement/agreement.component';
import { EnrollmentEntryComponent } from '@app/root/components/enrollment-entry/enrollment-entry.component';
import { LoginComponent } from '@app/root/components/login/login.component';
import { PassForgotComponent } from '@app/root/components/pass-forgot/pass-forgot.component';
import { PassResetComponent } from '@app/root/components/pass-reset/pass-reset.component';
import { TcComponent } from '@app/root/components/tc/tc.component';
import { TerminalEntryComponent } from '@app/root/components/terminal-entry/terminal-entry.component';
import { AuthService } from '@services/auth.service';
import { AuthGuard } from '@services/guards/auth-guard';
import { UserService } from '@services/user.service';

const routes: Routes = [
  { path: 'analytics', redirectTo: '/admin/claim-event-monitor', pathMatch: 'full' },
  { path: 'experience', redirectTo: '/admin/claim-event-monitor', pathMatch: 'full' },
  { path: 'ap', redirectTo: '/actions/patient', pathMatch: 'full' },
  { path: 'ap/:token', redirectTo: '/actions/patient/:token', pathMatch: 'full' },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'portal',
    loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule),
  },
  {
    path: 'terminal',
    loadChildren: () => import('./terminal/terminal.module').then(m => m.TerminalModule),
  },
  {
    path: 'pharmacy-enrollment',
    loadChildren: () => import('./terminal/terminal.module').then(m => m.TerminalModule),
  },
  {
    path: 'kiosk',
    loadChildren: () => import('./kiosk/kiosk-routing.module').then(m => m.KioskRoutingModule),
  },
  {
    path: 'actions',
    loadChildren: () => import('./actions/actions-routes').then(m => m.ActionsRoutes),
  },
  {
    path: 'ta/:token',
    component: TerminalEntryComponent,
  },
  {
    path: 'ta',
    component: TerminalEntryComponent,
  },
  {
    path: 'TA/:token',
    component: TerminalEntryComponent,
  },
  {
    path: 'TA',
    component: TerminalEntryComponent,
  },
  {
    path: 'pe/:token',
    component: EnrollmentEntryComponent,
  },
  {
    path: 'pe',
    component: EnrollmentEntryComponent,
  },
  {
    path: 'PE/:token',
    component: EnrollmentEntryComponent,
  },
  {
    path: 'PE',
    component: EnrollmentEntryComponent,
  },
  { path: 'tc/:tenant', component: TcComponent },
  { path: 'TC/:tenant', component: TcComponent },
  { path: 'Tc/:tenant', component: TcComponent },
  { path: 'tC/:tenant', component: TcComponent },
  { path: 'agreement', component: AgreementComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/forgot', component: PassForgotComponent },
  { path: 'terms-of-use', component: LegalTermsOfUseComponent },
  { path: 'privacy-policy', component: LegalPrivacyPolicyComponent },
  { path: 'login/reset', component: PassResetComponent },
  {
    path: '**',
    redirectTo: () => {
      const auth = inject(AuthService);
      if (auth.isUserAuthenticated()) {
        return UserService.getCurrentRole().defaultRoute;
      }
      return '/login';
    },
  }, // MUST BE LAST
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: !!sessionStorage.getItem('ROUTER_TRACE'),
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
